import React from "react";

export default function SgcFiltrosFooter({
  summary,
  onClear,
  clearLabel = "Restablecer filtros",
  unwrapped = false,
}) {
  const content = (
    <>
      {summary ? <div className="sgc-filtro-summary">{summary}</div> : null}
      <button type="button" className="sgc-filtros-reset" onClick={onClear}>
        <i className="bi bi-arrow-clockwise" aria-hidden />
        {clearLabel}
      </button>
    </>
  );

  if (unwrapped) {
    return <div className="sgc-filtros__footer-actions">{content}</div>;
  }

  return <div className="sgc-filtros__footer">{content}</div>;
}
